<div class="modal-header">
  <h4 class="modal-title pull-left">Add Location</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span>
  </div>
</div>

<div class="modal-body">
  <form name="form" #f="ngForm" novalidate>
    <!-- Address -->
    <div class="form-group">
      <label>Address</label>
      <input type="text" class="form-control" placeholder="Address" name="loc_address" [(ngModel)]="address" required />
    </div>

    <div class="row m-0">
      <!-- zip -->
      <div class="col-3 form-group p-0">
        <label>Zip</label>
        <div class="d-flex">
          <input type="text" class="form-control" (keypress)="commonService.isNumber($event);" name="loc_zip"
            placeholder="ZIP" [(ngModel)]="zip" minlength="5" maxlength="5" (ngModelChange)="zipEntered()" required />
          <span class="loading-icon-small loading-icon-margin" *ngIf="showZipLoading"></span>
        </div>
      </div>

      <!-- City -->
      <div class="col-md-5 form-group pr-0">
        <label>City</label>
        <input type="text" class="form-control" placeholder="City" name="loc_city" [(ngModel)]="city" required />
      </div>

      <!-- State -->
      <div class="col-md-4 form-group pr-0">
        <label>State</label>
        <select class="form-control" name="loc_state" [(ngModel)]="state" required>
          <option value="">Select State</option>
          <option *ngFor="let tempState of commonService.states" [ngValue]="tempState.value">{{tempState.name}}</option>
        </select>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button [disabled]="!f.form.valid" type="submit" class="btn btn-rbv" (click)="onConfirm()">Submit</button>
</div>